import React from 'react';
import Lottie from 'lottie-react';
import loadingAnimation from '../../../../public/assets/lotties/loading.json';
import { useTheme } from '@mui/material';
import { APP_CONFIG } from '../../../config/app.config';

const LoadingIndicator = () => {
  const theme = useTheme();
  const { primary } = APP_CONFIG.ui.theme.colors;

  return (
    <div style={{
      filter: `brightness(0) saturate(100%) ${primary}`,
      height: 24
    }}>
      <Lottie
        animationData={loadingAnimation}
        loop={true}
        style={{ height: '100%' }}
      />
    </div>
  );
};

export default LoadingIndicator; 